import { StyleSheet } from "@react-pdf/renderer";
import variables from "theme/styles/_variables.module.scss";

const nestedTableStyles = StyleSheet.create({
  page: {
    padding: 15,
  },

  printDate: {
    fontFamily: "MuseoSans",
    fontSize: 9,
    color: variables.black,
    textAlign: "right",
  },

  titleContainer: {
    paddingTop: 10,
    paddingBottom: 30,
    paddingLeft: 5,
  },

  title: {
    fontFamily: "MuseoSans",
    fontWeight: 900,
    fontSize: 18,
    color: variables.darkBlue,
    paddingBottom: 4,
  },

  subTitle: {
    fontFamily: "MuseoSans",
    fontWeight: 700,
    fontSize: 10,
    color: variables.darkGray,
  },

  table: {
    width: "100%",
    fontFamily: "MuseoSans",
    fontSize: 9,
  },
  row: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "nowrap",
  },

  header: {
    borderTop: "none",
    borderBottom: `2px solid ${variables.blueV4}`,
  },
  headerCell: {
    fontWeight: 700,
    color: variables.black,
    fontSize: 11,
    padding: 5,
  },
  headerSubCell: {
    fontWeight: 700,
    color: variables.gray,
    fontSize: 9,
    textAlign: "center",
    padding: 5,
  },

  flexRow: {
    display: "flex",
    flexDirection: "row",
  },
  rowLevel1: {
    borderBottom: `1px solid ${variables.printRowBorder}`,
  },
  rowLevel2: {
    borderBottom: `1px solid ${variables.printRowBorder}`,
  },
  rowLevel3: {
    backgroundColor: variables.lightBlueV3,
    borderBottom: `1px solid ${variables.printRowBorder}`,
  },

  rowLevel1MainText: {
    paddingLeft: 0,
  },
  rowLevel2MainText: {
    paddingLeft: 25,
  },
  rowLevel3MainText: {
    paddingLeft: 40,
  },

  cell: {
    padding: 5,
  },
  repeatCellMain: {
    color: variables.linkBlue,
  },
  repeatCellSecondary: {
    color: variables.darkGray,
  },

  titleRow: {
    fontWeight: 700,
    paddingTop: 5,
    paddingBottom: 3,
    color: variables.darkGray,
  },

  sumRow: {
    borderTop: `2px solid ${variables.darkBlue}`,
    fontWeight: 700,
    paddingBottom: 10,
  },
  sumPositive: {
    borderTop: `2px solid ${variables.greenV3}`,
    borderBottom: "transparent",
    backgroundColor: variables.lightGreenV2,
    paddingBottom: 10,
  },
  sumNegative: {
    borderTop: `2px solid ${variables.redV2}`,
    borderBottom: "transparent",
    backgroundColor: variables.lightRedV5,
    paddingBottom: 10,
  },

  totalCell: {
    backgroundColor: variables.totalCellSub,
  },

  empty: {},
});
export default nestedTableStyles;
